class PasteCommandService {
    constructor() {
       this.commandsQueue = [];
       this.wasFirstCommandExecuted = false;
       this.maxCommandsAllowed = 15;
    }

    addCommandToQueue(command) {
        if (this.getCommandsNumber() < this.maxCommandsAllowed) {
            this.commandsQueue.push(command);
        }

        if (!this.wasFirstCommandExecuted) {
            this.wasFirstCommandExecuted = true;
            this.execNextCommand();
        }
    }

    getCommandFromQueue() {
        return this.commandsQueue.shift();
    }

    execNextCommand() {
        const command = this.getCommandFromQueue();
        if (command) {
            command();
        }
        else {
            this.wasFirstCommandExecuted = false;
        }
    }

    getCommandsNumber() {
        return this.commandsQueue.length;
    }
}

export default new PasteCommandService();